module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="subscription-invitation-wrapper"><dl><dt>'+
((__t=( i18n.tc("SubscriptionInvitation", "Device:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( alias ))==null?'':__t)+
'</dd></dl><p class="error" data-text="process-subscription-invitation-error"></p></div><fieldset class="button-wrap"><button class="danger" data-click="subscription-reject">'+
((__t=( i18n.tc("SubscriptionInvitation", "Reject") ))==null?'':__t)+
'</button> <button class="success" data-click="subscription-accept">'+
((__t=( i18n.tc("SubscriptionInvitation", "Accept") ))==null?'':__t)+
'</button></fieldset><hr>';
}
return __p;
};
